import React, { useState, useEffect } from 'react';
import { principalService } from '../../services';
import { Select } from '../';
import { useMessage, useSearch } from '../../hooks';
import { Asset, AssetName } from '../../helpers';

export const SelectOwner = ({
  name,
  value,
  label,
  title,
  placeholder,
  onChange,
  disabled,
  principalTypes = [Asset.User, Asset.UserGroup],
  isNullable = false,
  isOptional,
}) => {
  const [currentValue, setCurrentValue] = useState();
  const [requestResults, setRequestResults] = useState([]);
  const [loadingMoreOptions, setLoadingMoreOptions] = useState(false);

  const { showMessage } = useMessage();
  const {
    searchTerm,
    searchResults,
    searchResultsCount,
    setSearchTerm,
    fetchDefaultSearchResults,
    clearSearchResults,
    loadNextPage,
  } = useSearch({
    setLoading: setLoadingMoreOptions,
    objectName: principalTypes,
    pagination: true,
    enableHistory: false,
    useDefaultValues: true,
  });

  useEffect(() => {
    if (value && value !== currentValue?.value) {
      fetchOwner();
    }
  }, [value]);

  useEffect(() => {
    const formatSearchResults = result => {
      switch (result.object_name) {
        case Asset.User:
          return {
            value: result.searchable.principal_id,
            label: result.searchable.user_fullname,
            secondaryLabel: result.searchable.user_username,
            photo: result.searchable.user_photo,
          };
        case Asset.UserGroup:
          return {
            value: result.searchable.principal_id,
            label: result.searchable.user_group_name,
            secondaryLabel: AssetName[Asset.UserGroup],
            tooltip: result.searchable.user_group_description,
            photo: result.searchable.user_group_photo,
          };
        default:
        // Nothing
      }
    };
    setRequestResults(
      searchResults.reduce((res, result) => {
        res.push(formatSearchResults(result));
        return res;
      }, [])
    );
  }, [searchResults]);

  const fetchOwner = async () => {
    principalService
      .getById(value)
      .then(res => {
        res &&
          setCurrentValue({
            value: res.principals[0].principal_id,
            label: res.principals[0].principal_name,
            secondaryLabel:
              res.principals[0].principal_type === Asset.User
                ? res.principals[0].principal_username
                : AssetName[Asset.UserGroup],
            photo: res.principals[0].principal_photo,
          });
      })
      .catch(err => {
        showMessage(err, 'error');
      });
  };

  const handleChange = event => {
    if (!event.value || event.value === '') {
      setCurrentValue();
    } else {
      setCurrentValue({
        value: event.option.value,
        label: event.option.label,
        secondaryLabel: event.option.secondaryLabel,
        photo: event.option.photo,
      });
    }

    onChange && onChange(event);
  };

  const handleBlur = () => {
    setSearchTerm('');
  };

  const getOptions = () => {
    return [
      ...(currentValue && !requestResults.find(x => x.value === currentValue.value) && !searchTerm
        ? [currentValue]
        : []),
      ...requestResults,
    ];
  };

  return (
    <Select
      name={name}
      value={value}
      options={getOptions()}
      label={label}
      title={title}
      onInputChange={setSearchTerm}
      loadMoreOptions={loadNextPage}
      loading={loadingMoreOptions}
      searchTerm={searchTerm}
      resultCount={searchResultsCount}
      clearSearchResults={clearSearchResults}
      placeholder={placeholder || 'Search User or User Group...'}
      isClearable={true}
      isNullable={isNullable}
      onFocus={() => fetchDefaultSearchResults()}
      onBlur={handleBlur}
      onChange={handleChange}
      disabled={disabled}
      isOptional={isOptional}
    />
  );
};
